export const API_USERS_URL = {
  REVOKE: '/admin/api/v1/invitations',
  RESEND: '/admin/api/v1/invitations/resend',
  GET_LIST_USERS: '/admin/api/v1/users',
  GET_DETAILS_ORGANIZATION: '/admin/api/v1/organizations',
};

export const DEFAULT_TOAST_MESSAGE_RESEND_REVOKE = {
  SUCCESS: 'Operation was conducted successfully',
  ERROR: 'Operation failed. Please try again!',
};
